export default "__VITE_ASSET__ElUN7WiB__"